import React from "react";
import "./atoms.css";

const CheckIcon = ({ color }) => {
  const style = {
    fill: color,
    fillRule: "evenodd",
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.333"
      height="12"
      viewBox="0 0 13.333 12"
    >
      <path
        className="a"
        d="M47.845,91.657h0L46.178,93.35h0l-5,5.076h0a1.648,1.648,0,0,1-2.357,0h0l-3.333-3.385h0a1.7,1.7,0,0,1,1.178-2.888,1.647,1.647,0,0,1,1.179.5h0L40,94.837l3.821-3.881,1.667-1.692h0a1.648,1.648,0,0,1,1.178-.5,1.679,1.679,0,0,1,1.667,1.691,1.7,1.7,0,0,1-.488,1.2Z"
        transform="translate(-35 -88.769)"
        style={style}
      />
    </svg>
  );
};

export default CheckIcon;
